<template>
    <div>

        <header-app></header-app>

        <!--Content-->
        <div class="app-layout">
            <transition name="page">
                <router-view class="mb-92 router-content"></router-view>
            </transition>
        </div>

        <footer-app></footer-app>

        <div class="scroll-top cursor-pointer" @click="scrollTop()" v-if="scrollY">
            <div class="scroll-top-inner">
                <img src="/img/icons/scroll_top.svg" alt="top">
            </div>
        </div>

    </div>
</template>

<script>
    import filter from '../../services/filter';
    import store from '../../services/data';
    import order from '../../services/order';
    import moment from 'moment';

    export default {
        data() {
            return {
                filter: filter,
                store: store,
                order: order,
                scrollY: false,
            }
        },

        watch: {
            $route() {
                this.init();
                if (this.$route.name !== 'pages-catalog-category'
                    || this.$route.name !== 'pages-catalog-category-subcategory'
                    || this.$route.name !== 'pages-catalog'
                    || this.$route.name !== 'pages-catalog-new'
                    || this.$route.name !== 'pages-catalog-show') this.filter.state.active_category = null;
            }
        },
        created() {
            this.init();
        },

        props: {
            settings: {
                type: Object,
                required: true
            }
        },

        provide() {
            return {
                settings: this.settings
            };
        },

        mounted() {
            window.addEventListener("scroll", this.handleScroll);
            this.setCalendarData();
        },

        methods: {
            handleScroll() {
                if (window.scrollY > 0) {
                   this.scrollY = true;
                } else {
                    this.scrollY = false;
                }
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            init() {
                if (this.$route.meta.title) {
                    document.title = this.$route.meta.title;
                } else if (!document.title) {
                    document.title = 'Фотопрокат MRental - прокат фото, видео и кинотехники в Минске без залога.';
                }
                if (this.$route.meta.content) {
                    document.querySelector('meta[name="description"]').setAttribute("content",  this.$route.meta.content);
                    document.querySelector('meta[name="twitter:description"]').setAttribute("content",  this.$route.meta.content);
                    document.querySelector('meta[property="og:description"]').setAttribute("content",  this.$route.meta.content);
                    document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  this.$route.meta.content);
                }
                let canonical = window.location.origin + window.location.pathname;
                document.querySelector('link[rel="canonical"]').setAttribute("href",  canonical);
            },

            setCalendarData() {
                if(localStorage.getItem('dateStart')) {
                    const timeStart = {hour: 0, minute: 0, second: 0, millisecond: 0};

                    let date_now = moment(new Date()).set(timeStart).format();
                    let date_start = moment(new Date(JSON.parse(localStorage.getItem('dateStart')))).set(timeStart).format();
                    let date_end = moment(new Date(JSON.parse(localStorage.getItem('dateEnd')))).set(timeStart).format();

                    if((date_start.valueOf() > date_now.valueOf()) || date_now.valueOf() == date_start.valueOf()) {
                        this.store.state.dates.start = new Date(JSON.parse(localStorage.getItem('dateStart')));
                        this.store.state.dates.end = new Date(JSON.parse(localStorage.getItem('dateEnd')));
                        this.store.state.timeStart.HH = JSON.parse(localStorage.getItem('timeHHStart'));
                        this.store.state.timeStart.mm = JSON.parse(localStorage.getItem('timeMinStart'));
                        this.store.state.timeEnd.HH = JSON.parse(localStorage.getItem('timeHHEnd'));
                        this.store.state.timeEnd.mm = JSON.parse(localStorage.getItem('timeMinEnd'));

                        this.store.getItemBasketData();
                        this.store.getCommonPrice();
                    }
                }
            },

            echoDate(date) {
                return order.echoDate(date);
            }
        }
    }
</script>
